import { useEffect, useState } from "react";
import DonutChart from "../components/donutChart";
import { useTheme } from "next-themes";
import ArticleSlider from "../components/articleSlider";
import { format4, numberWithCommas, separateDecimal, separateNumberParts } from "../utils/numbers";
import { getFunds, getGoals } from "../services/dashboard.service";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { useAuth } from "../store/AuthContext";
import { getFundsByAmcCode } from "../services/funds.service";
import { getUnitholderDetails } from "../services/auth.service";
import { useTranslation } from "react-i18next";
import PortfolioChart from "../components/portfolioChart";
import DashboardFundItem from "../components/dashboardFundItem";
import FundDetailsModal from "../components/modals/fundDetails";

const Dashboard = () => {
  const [screenSize, setScreenSize] = useState();

  const [goals, setGoals] = useState([
    { goal_name: "test 1", target_amount: "12000" },
    { goal_name: "test 1", target_amount: "12000" },
    { goal_name: "test 1", target_amount: "12000" },
    { goal_name: "test 1", target_amount: "12000" },
    { goal_name: "test 1", target_amount: "12000" },
    { goal_name: "test 1", target_amount: "12000" },
  ]);
  const [funds, setFunds] = useState([]);
  const [unitHolderDetails, setUnitHolderDetails] = useState(null);
  const [portfolioFunds, setPortfolioFunds] = useState(null);
  // const [showFundsDetail, setShowDetails] = useState(() => ({
  //   show: false,
  //   symbol: ""
  // }));

  const { theme } = useTheme();
  const { user } = useAuth();
  const { setActiveMenuItem } = useOutletContext();
  const { t } = useTranslation();

  const { showDetails, setShowDetails } = useOutletContext();

  const navigate = useNavigate();

  const updateGoals = (data) => {
    setGoals(data);
  };

  const updateFunds = (data) => {
    setFunds(data);
  };

  const getUnitholderFunds = async (investFunds) => {
    if (user) {
      const response = await getUnitholderDetails(user.data.email, user.data.folio_no, user.data.amc_code);
      let localDataBeforeRender = null;

      if (!response.error) {
        await new Promise((res) => setTimeout(() => res(), 1000));

        localDataBeforeRender = response.data[0];

        const unitHolderFunds = JSON.parse(localDataBeforeRender.balance_unit);

        if (unitHolderFunds.length !== 0) {
          const updatedUnitholderFunds = unitHolderFunds.map((item) => {
            const copy = investFunds.find((fund) => item.fund_code == fund.symbol_code);

            return {
              ...copy,
              ...item,
              // case where fund doesnt exist or has been deleted
              navData: copy?.navData || null,
              fund_name: copy?.fund_name || '',
            };
          });

          setPortfolioFunds(updatedUnitholderFunds);
        }
        setUnitHolderDetails(localDataBeforeRender);

        // setPortfolioFunds(JSON.parse(localDataBeforeRender.balance_unit));
        // console.log(JSON.parse(response.data[0].balance_unit))
      }
    }
  }

  const setDataOnMount = async (isUser) => {

    const investFunds = await getFundsByAmcCode(isUser);

    if (!investFunds.error) {
        updateFunds(investFunds.data || []);

        return Promise.resolve(investFunds.data)
    }

    return Promise.reject(null)
  };

  const isUnitholder = (user && !user?.requiresDocumentVerification) ? true : false;


  useEffect(() => {
    // getGoals(updateGoals);
    // getFunds(updateFunds);

    setDataOnMount(user).then(data => {
      if (data.length !== 0) {
        getUnitholderFunds(data);
      }
    });

    const resizeScreen = () => {
      setScreenSize(window?.innerWidth);
    };

    resizeScreen();

    window.addEventListener("resize", resizeScreen);

    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  }, []);

  const navigateToGoals = () => {
    setActiveMenuItem("goals");
    navigate("/goals", { replace: true });
  };

  return (
    <div
      className={`row w-100 mx-auto justify-content-start p-1 py-2 px-2 px-sm-3 py-sm-3 row-gap-2 row-gap-sm-3 ${isUnitholder ? "row-cols-lg-2" : "row-cols-lg-1"} align-items-stretch`}
      style={{
        maxHeight: screenSize <= 575 ? "calc(100dvh - 148px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100dvh - 202px)" : "calc(100dvh - 128px)",
        minHeight: screenSize <= 575 ? "calc(100dvh - 148px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100dvh - 202px)" : "calc(100dvh - 128px)",
        overflowY: "auto",
        scrollbarWidth: "none",
        borderRadius: '20px',
        // backgroundColor: theme === "dark" ? "var(--theme-dark-one)" : "var(--theme-light-one)",
        backgroundColor: "var(--theme-bg)",
        // borderBottomLeftRadius: "20px",
        // borderBottomRightRadius: "20px",
      }}
    >
      {(isUnitholder) ? (
        <>
          <div className='col-12 col-lg p-0 pe-lg-2 animate-card' style={{}}>
            <div
              className='h-100 p-3 px-2 pb-2 px-sm-3 pb-sm-3 d-flex flex-column justify-content-start'
              style={{
                // backgroundColor: theme === "light" ? "rgb(240, 245, 255)" : "rgb(100, 100, 100)",
                backgroundImage: "linear-gradient(120deg, var(--theme-card-primary-bg) 0%, var(--theme-card-secondary-bg) 100%)",
                border: '1px solid',
                borderColor: 'var(--theme-card-border)',
                borderRadius: "20px",
                minHeight: "400px",
                boxShadow: "rgba(99, 99, 99, 0.15) 0px 2px 8px 2px",
              }}
            >
              <div
                className='text-center'
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "500",
                  color: theme === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
                }}
              >
                {t("app.cards.invest")}
              </div>
              <hr
                className='m-0 mt-3'
                style={{
                  color: theme === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
                }}
              />

              <div className='flex-grow-1 d-flex flex-column justify-content-center'>
                <DonutChart
                  // options={donutOption}
                  data={portfolioFunds ? portfolioFunds : []}
                  showTitle={false}
                  style={{
                    minHeight: screenSize >= 576 ? "320px" : "350px",
                  }}
                  theme='light'
                />
              </div>
            </div>
          </div>
          {/* <div className='col-12 col-md p-0 ps-md-2 animate-card' style={{}}>
            <div
              className='h-100 p-3 px-2 pb-2 px-sm-3 pb-sm-3 d-flex flex-column justify-content-start'
              style={{
                backgroundImage: "linear-gradient(120deg, var(--theme-card-primary-bg) 0%, var(--theme-card-secondary-bg) 100%)",
                border: '1px solid',
                borderColor: 'var(--theme-card-border)',
                borderRadius: "20px",
                minHeight: "400px",
                boxShadow: "rgba(99, 99, 99, 0.15) 0px 2px 8px 2px",
              }}
            >
              <div
                className='text-center px-3'
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "500",
                  color: theme === "light" ? "rgb(0,0,0)" : "rgb(240,240,240)",
                }}
              >
                {t("app.cards.goals")}
              </div>
              <hr
                className='m-0 mt-3 mx-3'
                style={{
                  color: theme === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
                }}
              />
              <div
                className={`flex-grow-1 d-flex flex-column justify-content-start column-gap-2 flex-nowrap px-1 add-custom-scroll-dashboard${theme === "dark" ? "-dark" : ""}`}
                style={{
                  height: "300px",
                  // minHeight: screenSize >= 576 ? '320px' : '350px',
                  // height: screenSize >= 576 ? 'calc(100vh - 595px)' : '350px',
                  // maxHeight: screenSize >= 576 ? 'calc(100vh - 595px)' : '350px',
                  paddingTop: ".75rem",
                  rowGap: ".75rem",
                  overflowY: "auto",
                  // scrollbarWidth: 'none'
                }}
              >
                {goals.map((item, index) => {
                  const progress = [24, 57, 46, 89, 33, 50, 67, 54, 20];

                  return (
                    <div
                      className='row w-100 mx-auto align-items-center p-3'
                      key={index}
                      style={{
                        lineHeight: "1",
                        // backgroundColor: theme === "light" ? "rgba(255, 255, 255, .8)" : "rgb(58, 58, 58)",
                        backgroundColor: "var(--theme-card-item-bg)",
                        borderRadius: "10px",
                        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                        rowGap: screenSize > 450 ? ".8rem" : "1.2rem",
                        columnGap: screenSize <= 450 && ".5rem",
                        color: theme === "light" ? "rgb(0,0,0)" : "rgb(240,240,240)",
                      }}
                      onClick={navigateToGoals}
                    >
                      <div className='col p-0'>
                        <div
                          className=''
                          style={{
                            fontSize: screenSize > 450 ? "0.8rem" : "0.75rem",
                            color: theme === "light" ? "rgba(0,0,0,0.45)" : "rgba(255,255,255,0.65)",
                          }}
                        >
                          {t("app.goal.title")}
                        </div>
                        <div
                          className='mt-1'
                          style={{
                            fontSize: screenSize > 450 ? "1.1rem" : "1rem",
                          }}
                        >
                          {item.goal_name}
                        </div>
                      </div>
                      <div className={`col p-0 ${screenSize > 450 ? "text-center" : "text-end"}`}>
                        <div
                          className=''
                          style={{
                            fontSize: screenSize > 450 ? "0.8rem" : "0.75rem",
                            color: theme === "light" ? "rgba(0,0,0,0.45)" : "rgba(255,255,255,0.65)",
                          }}
                        >
                          {t("app.goal.amount")}
                        </div>
                        <div
                          className='mt-1'
                          style={{
                            fontSize: screenSize > 450 ? "1.2rem" : "1.1rem",
                          }}
                        >
                          <span className='me-1' style={{ fontSize: ".8rem", color: theme === "light" ? "var(--theme-light-primary)" : "rgb(229, 124, 236)" }}>
                            Rs
                          </span>
                          {numberWithCommas(item.target_amount)}
                        </div>
                      </div>
                      {screenSize > 450 ? (
                        <div className='col p-0 text-end'>
                          <div
                            className=''
                            style={{
                              fontSize: "0.8rem",
                              color: theme === "light" ? "rgba(0,0,0,0.45)" : "rgba(255,255,255,0.65)",
                            }}
                          >
                          {t("app.goal.progress")}
                          </div>
                          <div
                            className='mt-1'
                            style={{
                              fontSize: "1.1rem",
                            }}
                          >
                            {progress[index]}
                            <span className='ms-1' style={{ fontSize: ".8rem", color: theme === "light" ? "var(--theme-light-primary)" : "rgb(229, 124, 236)" }}>
                              %
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className='col-12 p-0'>
                        <div
                          className='progress'
                          role='progressbar'
                          aria-label='Basic example'
                          aria-valuenow='75'
                          aria-valuemin='0'
                          aria-valuemax='100'
                          style={{
                            height: "0.3rem",
                            backgroundColor: theme === "light" ? "rgb(220, 223, 226)" : "rgb(121, 135, 149)",
                          }}
                        >
                          <div
                            className='progress-bar'
                            style={{
                              backgroundColor: theme === "light" ? "var(--theme-light-primary)" : "rgb(229, 124, 236)",
                              width: `${progress[index]}%`,
                              // width: '57%'
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {!goals.length ? <></> : ""}
              </div>
            </div>
          </div> */}
        </>
      ) : (
        ""
      )}
      <div className={`col-12 ${isUnitholder ? "col-lg" : "col-12"} p-0 ${isUnitholder ? "ps-lg-2" : "pe-lg-0"} animate-card`} style={{}}>
        <div
          className={'h-100 p-3 px-2 pb-2 px-sm-3 pb-sm-3 d-flex flex-column justify-content-start'}
          style={{
                backgroundImage: "linear-gradient(120deg, var(--theme-card-primary-bg) 0%, var(--theme-card-secondary-bg) 100%)",
                border: '1px solid',
                borderColor: 'var(--theme-card-border)',
            borderRadius: "20px",
            minHeight: "400px",
            boxShadow: "rgba(99, 99, 99, 0.15) 0px 2px 8px 2px",
          }}
        >
          <div
            className='text-center px-3'
            style={{
              fontSize: "1.4rem",
              fontWeight: "500",
              color: theme === "light" ? "rgb(0,0,0)" : "rgb(240,240,240)",
            }}
          >
            {t("app.cards.funds")}
          </div>
          <hr
            className='m-0 mt-3 mx-3'
            style={{
              color: theme === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
            }}
          />

          <div
            className={`flex-grow-1 d-flex flex-column justify-content-start column-gap-2 flex-nowrap pb-1 px-1 px-sm-1 add-custom-scroll-dashboard${theme === "dark" ? "-dark" : ""}`}
            style={{
              height: "300px",
              // minHeight: '300px',
              // maxHeight: screenSize <= 767 ? '300px' : '',
              paddingTop: ".75rem",
              rowGap: ".75rem",
              overflowY: "auto",
              scrollbarWidth: screenSize <= 575 ? 'none' : '',
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
            }}
          >
            {funds.length ? (
              funds.map((item, index) => {
                return (
                  <DashboardFundItem
                    onSelect={setShowDetails}
                    data={item}
                    key={index}
                  />
                )
              })
            ) : (
              <div className='h-100'>
                <div
                  className='w-100 h-100 d-flex align-items-center justify-content-center pb-3'
                  style={{
                    color: "white",
                    textDecoration: "none",
                  }}
                >
                  {/* <div className="" role="status" style={{
													fontSize: '1rem',
												}}>
													Loading Funds ...
												</div> */}
                  <div
                    className='spinner-border'
                    style={{
                      fontSize: "0.8rem",
                      height: "40px",
                      width: "40px",
                    }}
                  >
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <div className={`col-12 col-md p-0 ${user ? "pe-md-2" : "ps-md-2"} animate-card`} style={{}}>
        <div
          className='h-100 p-3 px-2 pb-2 px-sm-3 pb-sm-3'
          style={{
                backgroundImage: "linear-gradient(120deg, var(--theme-card-primary-bg) 0%, var(--theme-card-secondary-bg) 100%)",
                border: '1px solid',
                borderColor: 'var(--theme-card-border)',
            borderRadius: "20px",
            minHeight: "400px",
            boxShadow: "rgba(99, 99, 99, 0.15) 0px 2px 8px 2px",
          }}
        >
          <div
            className='text-center'
            style={{
              fontSize: "1.4rem",
              fontWeight: "500",
              color: theme === "light" ? "rgb(0,0,0)" : "rgb(240,240,240)",
            }}
          >
            {t("app.cards.articles")}
          </div>
          <hr
            className='m-0 mt-3'
            style={{
              color: theme === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
            }}
          />
          <div
            className=''
            style={{
              minHeight: "300px",
              height: "calc(100% - 50px)",
            }}
          >
            <ArticleSlider />
          </div>
        </div>
      </div> */}

      {/* <FundDetailsModal show={showFundsDetail.show} symbol={showFundsDetail.symbol} backdrop={true} keyboard={true} onClose={() => setShowDetails(() => ({ show: false, symbol: "" }))} /> */}
    </div>
  );
};

export default Dashboard;
